import React, { Component } from "react";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import BarChart from "app/components/charts/BarChart";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import StackedBarChart from "./StackedBarChart";
import JobTypeDropdown from "app/components/common/JobTypeDropdown";

import {
	FormControl,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { logActivity } from "../../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

class IndustryJobCounts extends Component {
  	constructor(props) {
		super(props);
		this.state = {
            chart1Index: 0,
		}
       this.countRadioRef = React.createRef();
       this.percRadioRef = React.createRef();

  	}

    addPropsToSeriesCountChart(series) {
		let colors = ["#FFB607", "#6AA4DC"];
		return (series.map((el,i) => ({
			...el,
			"color": colors[i],
			"borderColor": colors[i],
		})));
	}

    addPropsToSeriesPercChart(series) {
		let colors = ["#FB6A59"];
		return (series.map((el,i) => ({
			...el,
			"color": colors[i],
			"borderColor": colors[i],
		})));
    }

    handleClick = () => {
        if (this.countRadioRef.current.checked) {
            this.setState({
                chart1Index: 0,
              })
        } else if (this.percRadioRef.current.checked) {
            this.setState({
                chart1Index: 1,
              })
        }

		logActivity({
			screen : UserActivityConstants.SCREEN2.NAME,
			action_type : UserActivityConstants.ACTION_TYPES.CLICK,
			action : UserActivityConstants.SCREEN2.ACTIONS.TOGGLE_PRESENTATION_MODE,
			action_target : this.state.chart1Index === 0 ? "Percent" : "Counts"
		})
    }

  	render() {
		let count_data = [
			{
				"name" : "Change 2023-2033",
				"data" : this.props.countData["jobs_change"] ? [...this.props.countData["jobs_change"]] : []
			},{
				"name": "2023 jobs of industry",
				"data" : this.props.countData["jobs"] ? [...this.props.countData["jobs"]] : []
			}
		  ];

		let perc_data = [
			{
				"name" : "Percent Growth",
				"data" : this.props.percentData["percent"] ? [...this.props.percentData["percent"]] : []
			}
		  ]

		let minPercData = -10
		let maxPercData = 10
		let tickInterval = 2
		if (this.props.percentData["percent"]) {
		minPercData = Math.min(...this.props.percentData["percent"]);

		if (minPercData < 0) {
			minPercData = Math.floor(minPercData);
		} else {
			minPercData = Math.ceil(minPercData);
		}
			maxPercData = Math.max(...this.props.percentData["percent"]);
			maxPercData = Math.ceil(maxPercData);

			if ((minPercData < 0 && maxPercData < 0) || (minPercData >= 0 && maxPercData >= 0)) {
				tickInterval =  parseInt(Math.abs(Math.abs(maxPercData) - Math.abs(minPercData)) / 6)
			} else {
				tickInterval =  parseInt(Math.abs(Math.abs(maxPercData) + Math.abs(minPercData)) / 6)
			}
		}

		let intervalPower = String(tickInterval).length;
		tickInterval =  Math.ceil(tickInterval / Math.pow(10, intervalPower - 1)) * Math.pow(10, intervalPower - 1);

		let minCountData = -10
		let maxCountData = 10
		let countTickInterval = 15000
		if (this.props.countData["jobs"] && this.props.countData["jobs_change"]) {
			minCountData = Math.min(...this.props.countData["jobs_change"]);

		if (minCountData < 0) {
			minCountData = Math.floor(minCountData);
		} else {
			minCountData = Math.ceil(minCountData);
		}
			maxCountData = Math.max(...this.props.countData["jobs"]);
			maxCountData = Math.ceil(maxCountData);

			if ((minCountData < 0 && maxCountData < 0) || (minCountData >= 0 && maxCountData >= 0)) {
				countTickInterval = parseInt(Math.abs(Math.abs(maxCountData) - Math.abs(minCountData)) / 6)
			} else {
				countTickInterval = parseInt(Math.abs(Math.abs(maxCountData) + Math.abs(minCountData)) / 6)
			}
		}

		let countIntervalPower = String(countTickInterval).length;
		countTickInterval =  Math.ceil(countTickInterval / Math.pow(10, countIntervalPower - 1)) * Math.pow(10, countIntervalPower - 1);

		let componentObj = this;

		return (
	  		<div className="graph-wrapper screen-left-graph-container">
				<div className="graph-title-container">
					<div className="graph-title">Industry job counts and projected change</div>
					<JobTypeDropdown/>
				</div>
				<div className="legend-for-graph legend-for-graph2">
					<table>
						<tr>
                            <td><input type="radio" id="countRadio" name="toggler" value="count" style={{"height":"20px", "width":"20px"}}  ref = {this.countRadioRef} defaultChecked onClick={this.handleClick} /></td>
							<td className="legend-label"> Counts</td>
							<td><input type="radio" id="percentRadio" name="toggler" value="perc" style={{"height":"20px", "width":"20px"}} ref = {this.percRadioRef} onClick={this.handleClick}/></td>
							<td className="legend-label"> Percent</td>
                            {this.state.chart1Index === 0
                            ? <div className="legend-block">
                            <td className="square-shape" style={{ "backgroundColor": "#6AA4DC"}}></td>
							<td className="legend-label">2023 jobs of industry</td>
							<td className="square-shape" style={{ "backgroundColor": "#FFB607"}}></td>
							<td className="legend-label chart1-label">Change 2023-2033</td>
                            </div> :
                            <div className="legend-block">
                            <td className="square-shape" style={{ "backgroundColor": "#FB6A59"}}></td>
							<td className="legend-label">Percent Growth</td>
                            </div>
                            }

						</tr>
					</table>
				</div>
				<div className="graph-screen graph-screen2">
                {this.state.chart1Index === 0
                    ?
					<div className="individual-graph-2">
					<StackedBarChart
						containerId="stackChart"
						stacking="normal"
						remainingOptions={{
							chart: {
								animation: false,
								type: 'bar',
								backgroundColor: '#0F3E6E',
								height: 650,
								width: 825,
								spacingTop: 0,
								marginRight: 40,
                                dataLabels: false,
								scrollablePlotArea: {
									minHeight: 1200,
									opacity: 1
								},
							},
							plotOptions: {
								series: {
									point: {
										events: {
											mouseOver: function () {
												if(this.category !== componentObj.props.focusIndustry) {
													componentObj.props.setFocusIndustry(this.category);
												}
											},
											mouseOut: function () {
												if('' !== componentObj.props.focusIndustry) {
													componentObj.props.setFocusIndustry('');
												}
											}
										}
									},
									stacking: "normal",
									animation: false
								}
							},
							series: this.addPropsToSeriesCountChart(count_data),
							xAxis: {
								scrollbar: {
									enabled: true
								},
								categories: this.props.countData["labels"],
								title: {
									text: null,
								},
								labels: {
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial",
										width: "220px",
										textOverflow: "ellipsis",
										whiteSpace: "nowrap"
									}
								}
							},
							yAxis: {
								scrollbar: {
									enabled: true
								},
								offset: 10,
								title: {
									text: "Count of Jobs",
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial",
										letterSpacing: "0.49px"
									}
								},
								labels: {
									overflow: 'justify',
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									},
									formatter: function() {
										return (Math.abs(this.value) >= 1000) ? (this.value / 1000) + 'K' : this.value;
									}
								},
								tickInterval: countTickInterval,
								min: minCountData,
								gridLineWidth: 0.5
							},
							exporting: { enabled: false }
						}}
					/>
					</div> :
                    <div className="individual-graph-2" >
					<StackedBarChart
						containerId="stackChart"
						stacking="normal"
						remainingOptions={{
							chart: {
								type: 'bar',
								backgroundColor: '#0F3E6E',
								height: 650,
								width: 825,
								spacingTop: 0,
                                dataLabels: false,
								scrollablePlotArea: {
									minHeight: 1200,
									opacity: 1
								},
							},
							plotOptions: {
								series: {
									point: {
										events: {
											mouseOver: function () {
												if(this.category !== componentObj.props.focusIndustry) {
													componentObj.props.setFocusIndustry(this.category);
												}
											},
											mouseOut: function () {
												if('' !== componentObj.props.focusIndustry) {
													componentObj.props.setFocusIndustry('');
												}
											}
										}
									},
									stacking: "normal",
									animation: false
								}
							},
							series: this.addPropsToSeriesPercChart(perc_data),
							xAxis: {
								categories: this.props.percentData["labels"],
								title: {
									text: null
								},
								labels: {
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									}
								}
							},
							yAxis: {
								scrollbar: {
									enabled: true
								},
								offset: 10,
								title: {
									text: "Percent Growth (2023 - 2033)",
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial",
										letterSpacing: "0.49px"
									}
								},
								labels: {
									overflow: 'justify',
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial",
										letterSpacing: "0px"
									},
								},
								tickInterval: tickInterval,
								min: minPercData,
								gridLineWidth: 0.5
							},
							exporting: { enabled: false }
						}}
					/>
					</div>
    }
				</div>
			</div>
		);
  	}
}


export default IndustryJobCounts;
